import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContentText,
  Theme,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { PmiButton } from 'shell/components/shared/button';
import { PmiDialogContent } from 'shell/components/shared/dialog/content';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';

const useStyles = makeStyles((theme: Theme) => ({
  paper: { minWidth: '30rem', color: theme.palette.cdmBrand.main },
}));

interface ErrorModalProps {
  id: string;
  open: boolean;
  onClose: () => void;
  handleError: () => void;
  title: string;
  message: string;
}

const ErrorModal = ({
  id,
  open,
  onClose,
  message,
  title,
  handleError,
}: ErrorModalProps): React.ReactElement => {
  const classes = useStyles();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby={id}
      aria-describedby={id}
      classes={{ paper: classes.paper }}
      fullScreen={fullScreen}
    >
      <PmiDialogTitle id={`${id}-title`} color="white" backgroundColor="cdmBrand">
        {title}
      </PmiDialogTitle>
      <PmiDialogContent>
        <DialogContentText key={message} id={`${id}-content`}>
          {message}
        </DialogContentText>
      </PmiDialogContent>
      <DialogActions>
        <PmiButton onClick={handleError} variant="outlined" color="cdmBrand">
          Ho capito
        </PmiButton>
      </DialogActions>
    </Dialog>
  );
};

ErrorModal.displayName = 'Error modal component';

export default ErrorModal;
